import { getServerRequestContext } from '@coolblue-development/next-request-context/server';
import { cookies } from 'next/headers.js';
import { TranslationInfoCookieName, TranslationInfoCookieValue } from './translationsCookies.js';
export const isTranslationInfoEnabled = async () => {
    const { isInternalUser } = await getServerRequestContext();
    return (isInternalUser &&
        !!(await cookies()).get({
            name: TranslationInfoCookieName,
            value: TranslationInfoCookieValue,
        }));
};
//# sourceMappingURL=isTranslationInfoEnabled.js.map